const T = require("react").PropTypes;
const Config = require("../../Config.js");

/**
 * Specifies metadata for Marketing Assignments uploads.
 * 
 * Type gives us a shape to use in validating data passed to the component.
 * 
 * GetSpecData() generates a "Data" object for a MetadataSpec.
 */
var titleAbbr = "DIVISIONALTRAINER";

const DivisionAssignments = {
    // Factory method
    GetSpecData() {
        const spec = {
            // This points to a controller in the API
            SampleFileURL:  "StoreAssignment/" + titleAbbr + "/template",
            IsComplete: true,
            // This JSON is hard-coded and passed along to the worker
            Arg: "{\"titleAbbr\": \"" + titleAbbr  + "\"}"
        };

        return spec;
    },
    // This should mirror the spec type.
    Type: T.shape({
        SampleFileURL: T.string.isRequired
    })
};

module.exports = DivisionAssignments;


// WEBPACK FOOTER //
// ./src/types/metadata/DivisionAssignments.js